<template>
  <v-speed-dial
    v-model="fab"
    bottom="bottom"
    :right="right"
    :left="left"
    direction="top"
    class="fab-dial"
    fixed
    small
    :class="{nudgeBottom: nudgeBottom}">
    <v-btn
      slot="activator"
      :style="{color: getTextColor(color), backgroundColor: color}"
      dark
      fab
      v-model="fab"
    >
      <v-icon>{{fabIcon}}</v-icon>
      <v-icon>close</v-icon>
    </v-btn>
    <fab-button v-for="(button, key) in buttons" :key="key" :button="button" :text-direction="textDirection"/>
  </v-speed-dial>
</template>

<script>
  import FabButton from './FabButton'
  import Colors from '../../../mixins/Colors'

  export default {
    components: {FabButton},
    name: 'fab-dial',
    props: {
      color: {
        type: String,
        required: true
      },
      closedIcon: {
        default: 'account_circle'
      },
      openIcon: {
        default: 'close'
      },
      buttons: {
        required: true,
        type: Array
      },
      nudgeBottom: {
        default: false
      },
      fabIcon: {
        default: 'add'
      },
      right: {
        default: true
      },
      left: {
        default: false
      },
      textDirection: {
        default: 'right'
      }
    },
    mixins: [Colors],
    data () {
      return {
        fab: false
      }
    },
    methods: {},
    computed: {},
    watch: {}
  }
</script>

<style scoped>
  .fab-dial {
    transition: all 0.3s ease-out;
    z-index: 4;
  }

  .nudgeBottom {
    margin-bottom: 60px;
  }
</style>



// WEBPACK FOOTER //
// src/components/misc/fab/FabDial.vue